export default "__VITE_ASSET__DhsniJH1__"